import { DialogConfig } from '@ngneat/dialog';

export const DIALOG_SIZES = {
  sizes: {
    sm: {
      width: '470px',
    },
    md: {
      width: '570px',
    },
    lg: {
      width: '800px',
    },
    fullScreen: {
      width: '100vw',
      height: '100vh',
    },
  },
};

export const DIALOG_CONFIG: Partial<DialogConfig> = {
  backdrop: true,
  closeButton: false,
};
